<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <v-row>
          <v-col cols="9" class="pb-0">
            <span class="text-h5">Dados Gerais</span>
          </v-col>
          <v-col v-if="resumoProposta" cols="3" class="pb-0 text-right">
            <v-chip outlined small>Situação: {{model.SituacaoDescricao}}</v-chip>
          </v-col>

          <v-col cols="4">
            <span class="text-label">Documento Federal</span>
            {{model.Cliente.DocumentoFederal}}
          </v-col>
          <v-col cols="8">
            <span class="text-label">Nome / Razão Social</span>
            {{model.Cliente.Nome}}
          </v-col>

          <v-col cols="4">
            <span class="text-label">Tipo de Operação</span>
            {{ model.TipoOperacaoDescricao}}
          </v-col>
          <v-col cols="8">
            <span class="text-label">Produto</span>
            {{model.TipoContratoDescricao}}
          </v-col>
        </v-row>

        <v-row class="grey lighten-3 mt-4">
          <v-col cols="4">
            <span class="text-label">Prazo</span>
            {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento)}} até {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}
          </v-col>
          <v-col cols="4" class="text-center">
            <span class="text-label">Número de Prestações</span>
            {{model.Prazo}} {{model.Prazo > 1 ? 'prestações' : 'prestação'}}
          </v-col>
          <v-col cols="4" class="text-right">
            <span class="text-label">Valor da 1ª prestação</span>
            {{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal)}}
            <span class="text-caption" style="display: block;">última prestação: {{$api.UI.Format.Currency(model.UltimaParcela.VlrPrestacaoTotal)}}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0 mt-6">
            <span class="text-h5">Detalhamento do Crédito</span>
          </v-col>

          <v-col cols="12" style="max-width: 800px;" class="px-0">

          <div class="item-value">
            <span class="text-value-label">Valor Líquido Solicitado</span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSolicitado)}}</span>
          </div>

          <template>
            <div class="item-value" v-if="model.VlrSeguro">
              <span class="text-value-label">Seguro</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSeguro || 0)}}</span>
            </div>

            <div class="item-value" v-if="model.VlrOutrasDespesas">
              <span class="text-value-label">Valor Outras Despesas</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrOutrasDespesas || 0)}}</span>
            </div>
          </template>

          <div class="item-value grey lighten-3 py-2 my-2">
            <span class="text-value-label">Valor Total Solicitado</span>
            <span class="text-value">{{ $api.UI.Format.Currency(vlrTotalSolicitado)}}</span>
          </div>

          <div class="item-value">
            <span class="text-value-label">IOF</span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.VlrIOF)}}</span>
          </div>

          <div class="item-value">
            <span class="text-value-label">Tarifa de Cadastro</span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTAC)}}</span>
          </div>

          <div class="item-value grey lighten-3 py-2 my-2">
            <span class="text-value-label">Valor Total Financiado</span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalCredito)}}</span>
          </div>

          <div class="item-value">
            <span class="text-value-label">Taxa de Juros</span>
            <span class="text-value">{{ $api.UI.Format.Decimal(model.PercJurosMensal)}}% a.m. {{ $api.UI.Format.Decimal(model.PercJurosAnual)}}% a.a.</span>
          </div>

          <div class="item-value">
            <span class="text-value-label">CET</span>
            <span class="text-value">{{ $api.UI.Format.Decimal(model.PercCETMensal)}}% a.m. {{ $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.</span>
          </div>

          <div class="item-value mt-5">
            <span class="text-value-label">1º Prestação</span>
            <span class="text-value">
            {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }}<br />
            {{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal) }} <br />
            <span class="text-caption">
            Taxa de Juros a.m.: {{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% {{ model.TipoIndexador === 2 ? '+ ' + model.IndexadorPosFixado : ''}}
            </span>
            </span>
          </div>

          <div class="item-value mt-5">
            <span class="text-value-label">Última Prestação</span>
            <span class="text-value">
            {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }} <br />
            {{ $api.UI.Format.Currency(model.UltimaParcela.VlrPrestacaoTotal) }} <br />
            <span class="text-caption">
            Taxa de Juros a.m.: {{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% {{ model.TipoIndexador === 2 ? '+ ' + model.IndexadorPosFixado : ''}}
            </span>
            </span>
          </div>

          <div class="item-value grey lighten-3 py-2 my-2">
            <span class="text-value-label">Valor Total da Dívida</span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalDivida)}}</span>
          </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0 mt-6">
            <span class="text-h5">Fluxo de Pagamento</span>
          </v-col>
          <v-col cols="12" class="px-2 pt-0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center"> Parcela </th>
                    <th class="text-center"> Vencimento </th>
                    <th class="text-center"> Dias Corridos </th>
                    <th class="text-right"> Prestação </th>
                    <th class="text-right"> Saldo Devedor </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.Parcelas.length === 0">
                    <td colspan="7" class="text-center text--disabled">Aguardando geração das parcelas</td>
                  </tr>
                  <tr v-for="(item, index) in model.Parcelas" :key="index">
                    <template v-if="index < 3 || verTodasParcelas">
                      <td class="text-center">{{ (item.NumeroParcela || index) + 1 }}</td>
                      <td class="text-center">{{ $api.UI.Format.Date(item.DtVencimento) }}</td>
                      <td class="text-center">{{ item.Dias }} {{ item.Dias === 1 ? 'dia' : 'dias' }}</td>
                      <td class="text-right">{{ $api.UI.Format.Currency(item.VlrPrestacaoTotal) }}</td>
                      <td class="text-right">{{ item.VlrSaldoDevedor !== null ? $api.UI.Format.Currency(item.VlrSaldoDevedor) : '-' }}</td>
                    </template>
                    <td role="button" v-else-if="index === 3" colspan="7"
                      class="text-center text-decoration-underline primary--text" @click="verTodasParcelas = true">
                        ver todas as parcelas
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="resumoProposta && isLoaded">
          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos do Emitente</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" resumo :codigoProposta="model.Codigo" :codigoPessoa="model.CodigoCliente" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos da Proposta</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Proposta" resumo :codigoProposta="model.Codigo" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantias</span>
            </v-col>
            <v-col cols="12">
              <PropostaGarantia resumo :value="model"></PropostaGarantia>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  components: {
    PropostaGarantia: () => import('@/views/PropostaAddGarantias.vue'),
  },
  props: {
    resumoProposta: { type: Boolean, default: false },
    modal: { type: Boolean, default: false }
  },
  data () {
    return {
      model: {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {}
      },
      isLoaded: false,
      verTodasParcelas: false
    };
  },
  computed: {
    vlrTotalSolicitado () {
      return this.model.VlrSolicitado + (this.model.VlrSeguro || 0) + (this.model.VlrOutrasDespesas || 0)
    }
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model)
      this.isLoaded = true
    }
  }
}

</script>

  <style>

  #resumo-proposta span.text-label {
    display: block;
    font-weight:400;
  }

  #resumo-proposta span.text-h5 {
    font-weight: 400;
  }

  #resumo-proposta div.item-value {
    padding-bottom: 2px;
    padding-top: 2px;
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    justify-content: space-between;
  }

  #resumo-proposta span.text-value-label, #resumo-proposta span.text-subtitle-1 {
    font-weight: 400;
  }

  #resumo-proposta span.text-value {
    text-align: end;
  }
  </style>
